<template>
<div class="chapter">
<div class="inner_page">
<p class="label" id="ptI"><a id="page_15"><strong>I</strong></a></p><a id="page_15">
<p class="h2a"><strong>Location Choices of International Students and Return Migration</strong></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226695761_09_pt1.vue?3bd7fd51